/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'at': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9.392 4.803A13 13 0 0116 2.999a13.015 13.015 0 0113 13c0 .045 0 .09-.002.135v.055c-.043 1.782-.705 3.81-3.498 3.81-2.893 0-3.5-2.175-3.5-4v-5a1 1 0 00-2 0v.532a6.001 6.001 0 10.841 8.007c.125.217.266.425.422.62.671.84 1.951 1.84 4.237 1.84.758.011 1.512-.119 2.223-.382A13 13 0 119.392 4.803zM20 15.999a4 4 0 11-8 0 4 4 0 018 0z" _fill="#0B2C62"/>'
  }
})
